import { apiHelper } from "@/utils";
import { API } from "@/constants";

const API_URL = `${API.BASE_URL_API}/v1`;
export const productCategoryService = {
  getAll,
  store,
  show,
  update,
  updateStatus,
  softDelete,
};

export function getAll(filter = {}) {
  const params = { page: filter.pageNumber, size: filter.pageSize };
  if (filter.searchArray?.length) params.search_words = filter.searchArray;
  return apiHelper(API_URL).get("/product-categories", { params });
}
function payload(data) {
  return {
    name: data.name,
    description: data.description,
    is_active: Boolean(data.isActive),
  };
}
export function store(data) {
  return apiHelper(API_URL).post("/product-categories", payload(data));
}
export function show(uuid) {
  return apiHelper(API_URL).get(`/product-categories/${uuid}`);
}
export function update(data) {
  return apiHelper(API_URL).put(
    `/product-categories/${data.uuid}`,
    payload(data),
  );
}
export function updateStatus(uuid, isActive) {
  return apiHelper(API_URL).patch(`/product-categories/status/${uuid}`, {
    is_active: Boolean(isActive),
  });
}
export function softDelete(uuid) {
  return apiHelper(API_URL).patch(`/product-categories/delete/${uuid}`);
}
